// window.theme_custom = window.theme_custom || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------

theme_custom.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
theme_custom.ajaxGetcart = function(){
$.ajax({
    type: 'GET',
    dataType: 'html',
    url: '/',
    success: function (cart) {
        var cart_drawer_data = $(cart).find('#CartDrawer').html();
        $('#CartDrawer').html(cart_drawer_data);
        $('.drawer').removeClass('is-empty');
        $('.drawer').addClass('animate');
        $('.drawer').addClass('active');
        
    }
  });
}

theme_custom.clickEvent = function () {
  $('.cardCheckbox input').on('change', function(e){
     let sum = 0;
    let mainProductPrice = parseInt($('.getData').attr('data-product-price'));
    let priceArray = [];
    priceArray.push(mainProductPrice);
    setTimeout(function(){
      $('.sub_products .card_grid').each(function(){
      let price = parseInt($(this).find(':checked').attr('data-price'));
        if(price){
          priceArray.push(price);
        }
      }); 
     for (let i = 0; i < priceArray.length; i++) {
        sum += priceArray[i]
     }
      $('.upsell_combined_price').html(theme_custom.formatMoney(sum))
    },200);
   

    
  });
$('.adj_btn').on('click', function(e){
  e.preventDefault();
  let mainProductIncart = $('.getData').attr('data-incart');
  let mainProductvariantId = parseInt($('.getData').attr('data-mainVariant-id'));
  console.log(mainProductIncart)
  
  var form = $(this).parent('form');
  let product_id = [];
  if(mainProductIncart == 'false'){
    product_id.push({id:mainProductvariantId,quantity:1});
  }
  $('.sub_products .card_grid').each(function(){
    let variantId = $(this).find(':checked').attr('data-id');
    if(variantId){
      product_id.push({id:variantId,quantity:1});
    }
  });
    if(product_id.length){
       $.ajax({
      url: "/cart/add.js",
      dataType: "json",
      type: "POST",
      data: { 'items': product_id },
      success: (response) => {
        theme_custom.ajaxGetcart();
        if($('.getData').length){
          if(mainProductIncart == 'false'){
            $('.getData').attr('data-incart','true')
          }
        }
        }
      });
    }
  });
}



theme_custom.init = function () {
  theme_custom.clickEvent();
  
}
$(document).ready(function () {
  theme_custom.init();
});



$( window ).on("load", function() {
  if($("#shopify-section-template--15912125595799__1662901160b864775a").length > 0){
    var helo = $("#shopify-section-template--15912125595799__1662901160b864775a").offset().top;
    $(window).scroll(function (event) {
      var scroll = $(window).scrollTop();
      if(  scroll > helo){
        $('div#shopify-section-header').addClass('sticky');
        $('div#shopify-section-header').removeClass('gototopshow');
    }
    else{
        $('div#shopify-section-header').removeClass('sticky');
        $('div#shopify-section-header').addClass('gototopshow');
    }
    });
  }

  
  document.addEventListener("DOMContentLoaded", function(){  
  $(window).scroll(function(event) {
  var scroll = $(window).scrollTop();
  if (scroll > 750) {
    $('#myHeader').addClass('sticky');
    $('#myHeader').removeClass('gototopshow');
  } else {
    $('#myHeader').removeClass('sticky');
    $('#myHeader').addClass('gototopshow');
  }
});
  });

  
  });


//hompage slider
$(document).ready(function() {
   $(".custom_product_grid__slider").slick({
   slidesToShow: 3,
   infinite:false,
     dots:true,
   slidesToScroll: 1,
     responsive: [
    {
      breakpoint: 1024,
      settings: {
        arrows: false,
        slidesToShow: 2
      }
    },
       {
      breakpoint: 991,
      settings: {
        arrows: false,
        slidesToShow: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        slidesToShow: 1
      }
    },
       {
      breakpoint: 767,
      settings: {
        arrows: false,
        slidesToShow: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        slidesToShow: 1
      }
    }
  ]
  });

    $('.product_list_wrapper').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    autoplay: false,
    arrows: true,
    prevArrow: $('.pr_left'),
    nextArrow: $('.pr_right'),
    responsive: [
  {
    breakpoint: 480,
    settings: {
      slidesToShow: 1
    }
  }
] 
  });

 $('.cs-menu-Producten span').click(function(){
    $('#block-co2_meter').css('display','flex');
    console.log('yes');
    $('.custom_mainmenu_product_grid_card').not('#block-co2_meter').css('display','none');
 });

var data = $('.footer_class').attr('data-show');
 if(data == '1'){
  window.location.replace("https://www.rovary.com/pages/bedankt-pagina");
}
  
});
 